import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import { isFunction } from 'lodash';
import { Classes, IconClasses, Button, Collapse } from '@blueprintjs/core';

const VXBadge = ({ children }) => (
  <glamorous.Span
    minWidth={10}
    padding=".3em .5em .2em"
    fontSize=".6em"
    fontWeight={700}
    lineHeight={1}
    color="#fff"
    textAlign="center"
    background="#8CC841"
    borderRadius={4}
  >
    {children}
  </glamorous.Span>
);

const VXBoxHeader = ({ title, isExpanded, onToggleCollapse, badge }) => (
  <glamorous.Div
    borderTop="2px solid #999"
    display="flex"
    flex="1"
    justifyContent="space-between"
    paddingBottom={5}
    alignItems="center"
    minHeight={35}
  >
    <glamorous.H6
      color="#666"
      fontSize={13}
      fontWeight="bold"
    >
      {title}{' '}
      {!!badge && <VXBadge>{badge}</VXBadge>}
    </glamorous.H6>
    {isFunction(onToggleCollapse) &&
    <Button
      className={Classes.MINIMAL}
      iconName={isExpanded ? IconClasses.CHEVRON_UP : IconClasses.CHEVRON_DOWN}
      onClick={onToggleCollapse}
    />}
  </glamorous.Div>
);

export const VXCollapsibleBox = (props) => (
  <glamorous.Div
    display="flex"
    flexDirection="column"
  >
    <VXBoxHeader {...props} />
    <Collapse isOpen={props.isExpanded} keepChildrenMounted={true}>
      {props.children}
    </Collapse>
  </glamorous.Div>
);

VXCollapsibleBox.propTypes = {
  isExpanded: PropTypes.bool,
};

VXBoxHeader.propTypes = {
  isExpanded: PropTypes.bool,
  badge: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  onToggleCollapse: PropTypes.func,
};

VXBoxHeader.defaultProps = {
  isExpanded: true,
};



// WEBPACK FOOTER //
// ./src/views/visions/vx-collapsible-box.js